<template>
  <OtherPriceHover multi :text="supplier.name" :original="productList" />
</template>

<script>
import { OtherPriceHover } from "@/modules/bookings.days";
import moneyService from "@/services/money";

export default {
  props: {
    supplier: Object,
  },
  components: {
    OtherPriceHover,
  },
  computed: {
    productList() {
      const environment = this.$store.getters["AccountStore/environment"];

      return (this.supplier.items || []).map((item) => ({
        hoverName: item.product?.label || "TBD",
        rate: _formatItemPrice(item, environment),
        priceLabel: _getPriceLabel(item),
      }));
    },
  },
};

function _getPriceLabel(item) {
  if (["TRANS", "TOUR", "TOUR_LEADER"].includes(item.productType)) {
    return "Per group";
  }

  switch (item.costType) {
    case "PP":
    case "PROOM":
      return "Per person";
    case "PG":
      return "Per group";
    case "PD":
      return "Per day";
    default:
      return "Quoted price";
  }
}

function _formatItemPrice(item, environment) {
  const value = item.productCost?.value?.default;
  if (value == null || value === "") return "—";

  const source = moneyService.getCurrencySource(environment);
  const formatted = moneyService.format(value, source.money);
  const currency = item.productCost?.currency;

  return currency ? `${currency} ${formatted}` : formatted;
}
</script>
